import React from 'react'
import { Redirect, useHistory, useLocation, useParams } from 'react-router-dom'

import { Icon, palette } from '@centivo/react-components'
import {
  ProviderProfilePage,
  useProviderProfilePage,
} from '@centivo/provider-directory-components'

import { useDirectoryAdapter } from 'src/refactor/hooks'
import {
  buildProfileLocation,
  parseProfileSearch,
} from 'src/refactor/helpers/profileNavigation'

import { StyledInstitutionProfilePage } from './InstitutionDetails.styled'

export const InstitutionDetails: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const { search } = useLocation()
  const history = useHistory()
  const { directoryAdapter, mapboxAccessToken } = useDirectoryAdapter()
  const { fetchParams, distance } = parseProfileSearch(search)

  const { providerProfilePage } = useProviderProfilePage({
    entityType: 'institution',
    entityId: id ?? '',
    distance,
    fetchParams,
    fetchProviderDetail: directoryAdapter.fetchProviderDetail,
    fetchInstitutionDetail: directoryAdapter.fetchInstitutionDetail,
    fetchInstitutionProviders: directoryAdapter.fetchInstitutionProviders,
    mapboxAccessToken,
    onSelectProvider: providerId =>
      history.push(buildProfileLocation('doctor', providerId, { fetchParams })),
  })

  if (!id) return <Redirect to="/results" />

  return (
    <StyledInstitutionProfilePage>
      <button className="back-button" type="button" onClick={history.goBack}>
        <Icon icon="arrow-left" color={palette.brand.brown} size="1.5rem" />
        <h3>Back</h3>
      </button>
      <ProviderProfilePage {...providerProfilePage} />
    </StyledInstitutionProfilePage>
  )
}
